/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { ProgramSupportSt } from '@ieo/Common/CompLangConfig';
import ProgramSupportCard from '@ieo/Components/Cards/ProgramSupportCard';
import RemarketProgramSupportCard from '@ieo/Components/Cards/RemarketProgramSupportCard';
import { usePathname } from 'next/navigation';

/* Services */
/* Styles */

/**
 *
 * @param {Object} sectionContent
 *  @param {String} lang
 *  @param {String} region
 * @returns {ReactElement} ProgramSupport
 */
const ProgramRemarkSupport = ({ sectionContent, region, lang, pageData }) => {
  // const isMobile = useMediaQuery({ maxWidth: 560 });
  const path = usePathname();
  const url = path.includes('offer/under-25s');
  const remarketUrl = path.includes('/rt-1');

  // console.log('sectionContent', sectionContent);
  return (
    <Box
      pos="relative"
      maxH={url && '100%'}
      overflow={url && 'hidden'}
      id="program-for-you-remark"
      w="100%"
      _before={{
        content: "''",
        position: 'absolute',
        display: { base: 'none', md: url && 'block' },
        width: 370,
        height: 600,
        backgroundImage:
          'https://static.sadhguru.org/d/46272/1710580730-5-copy-2-4-1.png',
        backgroundPosition: 'top',
        left: '-95px',
        top: 0,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box
        maxW={1030}
        w="100%"
        mx="auto"
        pos="relative"
        mt="50px"
        dir={lang == 'ar' ? 'rtl' : 'ltr'}
      >
        <Flex
          as="section"
          w="full"
          // mt={{ md: '100px', xl: '146px' }}
          mb={{ base: '60px', md: '100px' }}
          flexDir="column"
          mx="auto"
          //pt={{ md: "120px" }}
        >
          <StructuredTextParser
            str={render(sectionContent?.[2]?.body)}
            as="h2"
            {...ProgramSupportSt[lang].h2}
            color="#12166F"
            p={{ base: '4px', lg: '0 0 40px 0' }}
            mb={8}
            fontSize={{ base: '1.375rem', md: '2.125rem' }}
            lineHeight={{ base: '1.788rem', md: '2.76rem' }}
            textAlign={lang == 'ar' ? 'right' : 'center'}
          />
          <Flex
            flexWrap="wrap"
            justifyContent="center"
            gridColumnGap={{ base: '38px', md: '38px' }}
            gridRowGap={{ base: '20px', md: '40px' }}
            css={{
              '-webkit-grid-row-gap': '25px !important',
              '-webkit-grid-column-gap': '38px',
            }}
          >
            {sectionContent[3]?.cards?.map((card, index) => {
              return (
                <>
                  {remarketUrl ? (
                    <RemarketProgramSupportCard
                      card={card}
                      lang={lang}
                      region={region}
                      key={nanoid()}
                      color="#A81D28"
                      pageData={pageData}
                      flexBasis={index === 1 ? '30%' : 'auto'}
                    />
                  ) : (
                    <ProgramSupportCard
                      card={card}
                      lang={lang}
                      region={region}
                      key={nanoid()}
                      // w={{ base: '100%', md: '47%', lg: '30%' }}
                      // h={{ base: '100%', md: '254px' }}
                      // bg="#F1EBDF"
                      // display="flex"
                      // justifyContent="space-between"
                      // flexDir="column"
                      color="#A81D28"
                      pageData={pageData}
                      flexBasis={index === 1 ? '30%' : 'auto'}
                    />
                  )}
                </>
              );
            })}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default ProgramRemarkSupport;
